/**
 * getVideoDuration function
 * Reads a video file's duration (in seconds) by loading its metadata into an
 * off-DOM video element. Used to validate uploads against the max duration cap.
 *
 * @param file - The video file to measure
 * @returns A promise resolving to the video duration in seconds
 */
export const getVideoDuration = (file: File): Promise<number> => {
  return new Promise<number>((resolve, reject) => {
    const video = document.createElement("video");
    video.preload = "metadata";
    const objectUrl = URL.createObjectURL(file);

    video.onloadedmetadata = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(video.duration);
    };

    video.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("Failed to read video metadata"));
    };

    video.src = objectUrl;
  });
};
